import { render, staticRenderFns } from "./StrapiActualiteView.vue?vue&type=template&id=6a086fbb"
import script from "./StrapiActualiteView.vue?vue&type=script&lang=js"
export * from "./StrapiActualiteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports